import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetSportUnits } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { sportOccupationsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfSportSectionContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentOccupations = useAppSelector(sportOccupationsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().sportSections });

  const hasData = studentOccupations.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(studentOccupations, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Кружки и секции" Icon={IconWidgetSportUnits}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfSportSectionContainer;
